import { getChallengeMinWordLengthInfo } from '~/boggle/gameModes/minWordLengthVariants'
import { getRaceChallengeIntervalTimeInfo } from '~/boggle/gameModes/raceSpeedVariants'
import type { AnyBoggleChallengeCoreDefinition } from '~/boggle/gameModes/types'
import type { BogglePlaygroundSettings } from '~/boggle/config/playground'
import { BOGGLE_CHALLENGE_GRID_SIZE_CORE_DEFINITION } from '../shared/gridSizeCore'

export const RACE_CHALLENGE_CORE_DEFINITIONS = [
  BOGGLE_CHALLENGE_GRID_SIZE_CORE_DEFINITION,
  {
    createPatch: (value: number) => ({
      minWordLength: value,
    }),
    getInfo: getChallengeMinWordLengthInfo,
    id: 'min-word-length',
    label: 'Minimum Letters',
    readValue: (settings: BogglePlaygroundSettings) => settings.minWordLength,
    renderValue: (value: number) => value,
    isRow: true,
  },
  {
    createPatch: (value: number) => ({
      intervalCount: 1,
      intervalTimeSeconds: value,
    }),
    getInfo: getRaceChallengeIntervalTimeInfo,
    id: 'interval-time',
    label: 'Time',
    readValue: (settings: BogglePlaygroundSettings) => settings.intervalTimeSeconds,
    renderValue: (value: number) => value,
  },
] as const satisfies readonly AnyBoggleChallengeCoreDefinition[]
